import React from "react"
import { useMediaQuery } from "react-responsive"
import { Box, Typography } from "src/UILibrary"

export const QuestionItem = ({ question }: { question: string }) => {
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1200px)" })
  return isDesktopOrLaptop ? (
    <Box sx={{ mt: "40px", mx: "0px", p: "20px", borderBottom: "1px dotted #D4D3D7;" }}>
      <Typography.Title sx={{ mt: "0px", fontWeight: 500 }} color="textPrimary">
        {`Q : ${question}`}
      </Typography.Title>
    </Box>
  ) : (
    <Box sx={{ mt: "0px", mx: "0px", p: "20px", borderBottom: "1px dotted #D4D3D7;" }}>
      <Typography.Title sx={{ mt: "0px", fontWeight: 500 }} color="textPrimary">
        {`Q : ${question}`}
      </Typography.Title>
    </Box>
  )
}
